<template>
    <div>
        <v-app-bar color="#008dd4" height="160">
            <v-toolbar-title>
                <v-img src="/images/neumann-logo-contorno.png" class="mx-auto" width="250"></v-img>
            </v-toolbar-title>
        </v-app-bar>
        <v-container>
            <v-row align="center" justify="center">
                <v-col cols="12" lg="8" transition="dialog-bottom-transition" style="position:relative; margin-top: -60px">
                    <v-card outlined class="rounded-lg">
                        <template v-if="introduction">
                            <v-card-title>Test de nivelación {{ language.language }}</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-row justify="center" align="center">
                                    <v-col cols="12" lg="5" md="6" sm="12">
                                        <v-img :src="image_url+language.image" width="300" height="300" class="rounded-xl mx-auto"></v-img>
                                    </v-col>
                                    <v-col cols="12" lg="5" md="6" sm="12">
                                        <p>{{ language.exam.description }}</p>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text href="/placement-test">Atrás</v-btn>
                                <v-btn color="#008dd4" x-large dark @click="introduction = false">Iniciar</v-btn>
                            </v-card-actions>
                        </template>
                        <template v-else>
                            <v-card-title>
                                <span v-if="current_question.type === 'question'" class="py-7">
                                        {{ current_question.value }}
                                </span>
                                <span v-else>
                                    Observa el video y responde correctamente
                                </span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text :class="current_question.type === 'video' ? 'px-0 py-0' : ''">
                                <v-row justify="center" align="center" v-if="current_question.type === 'video'" class="mx-0 py-0" style="background-color: #000">
                                    <v-col cols="12" lg="9" md="6" sm="12">
                                        <div class="embed-container" v-html="current_question.value"></div>
                                    </v-col>
                                </v-row>
                                <v-card-subtitle>Selecciona la opción correcta</v-card-subtitle>
                                <v-list rounded :disabled="check_response_flag">
                                    <v-list-item-group v-model="selected_response" :color="check_response_flag ? 'error' : 'primary'">
                                        <template v-for="(option, index) in current_question.options" >
                                            <v-list-item :class="check_response_flag && option.correct ? correct_class : ''" :key="index">
                                                <v-list-item-icon>
                                                    <v-icon v-if="!check_response_flag">
                                                        mdi-radiobox-marked
                                                    </v-icon>
                                                    <v-icon v-else-if="option.correct">
                                                        mdi-check
                                                    </v-icon>
                                                    <v-icon v-else color="error">
                                                        mdi-close
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="option.value"></v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#008dd4" x-large :disabled="selected_response == undefined || selected_response === ''" v-if="!check_response_flag" @click="check_response" class="white--text">VERIFICAR</v-btn>
                                <v-btn color="#008dd4" x-large v-else dark @click="change_question(question_index, levels[levels_index])">Continuar</v-btn>
                            </v-card-actions>
                        </template>
                    </v-card>
                </v-col>
            </v-row>

            <v-dialog v-model="results" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar flat color="#008dd4" dark>
                        <v-toolbar-title>Resultados</v-toolbar-title>
                    </v-toolbar>
                    <v-container class="py-0" fluid>
                        <v-row>
                            <v-col cols="12" class="pa-0">
                                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                            </v-col>

                            <v-col cols="12" style="position:relative; top: -60px">
                                <v-row justify="center" align="center">
                                    <v-col cols="12" xl="7" lg="7" md="10" sm="12">
                                        <v-card>
                                            <v-card-title>Nivel alcanzado : </v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text class="text-h4 py-3 text-center">{{ levels[levels_index] }}</v-card-text>
                                        </v-card>

                                        <v-card class="mt-3" :loading="loading">
                                            <v-card-title>Cursos recomendados para ti</v-card-title>
                                            <v-card-text>
                                                <template v-if="loading">
                                                    <v-progress-circular indeterminate color="primary" class="mx-2"></v-progress-circular>
                                                    Obteniendo cursos...
                                                </template>
                                                <template v-else>
                                                    <v-card v-for="(course, index) in order_courses" :key="index" class="mb-3" outlined>
                                                        <v-card-text class="py-0 px-0">
                                                            <v-container class="py-0 px-0" fluid>
                                                                <v-row no-gutters>
                                                                    <v-col cols="12" lg="2" md="2" sm="12" xs="12" class="text-center align-center" style="background-color: #008dd4">
                                                                        <v-container fill-height class="px-0">
                                                                            <v-row>
                                                                                <v-col>
                                                                                    <h3 class="py-2 white--text">Inicio : {{ course.schedule[0].start_time }}</h3>
                                                                                    <v-divider dark></v-divider>
                                                                                    <h3 class="py-2 white--text">Fin : {{ course.schedule[0].end_time }}</h3>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-container>
                                                                    </v-col>
                                                                    
                                                                    <v-col class="px-2 py-2" cols="12" lg="9" md="9" sm="12" xs="12">
                                                                        <v-list-item-title>{{ course.name }}</v-list-item-title>
                                                                        <v-list-item-subtitle class="mt-4">Nivel : <strong>{{ course.level.name }}</strong></v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4">Lugares disponibles : <strong>{{ course.spaces }}</strong> </v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 1">Días : <strong>Lunes, Miércoles y Viernes</strong> </v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 2">Días : <strong>Martes y Jueves</strong> </v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 3">Días : <strong>Sábados</strong> </v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4" v-if="course.modality.id >= 4">Días : <strong>Lunes a viernes</strong> </v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4"><strong>Hora estándar del centro (GMT-6)</strong> </v-list-item-subtitle>
                                                                        <v-list-item-subtitle class="mt-4">Fecha tentativa de inicio : <strong>{{ course.date }}</strong> </v-list-item-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card-text>
                                                        <v-divider></v-divider>
                                                        <v-card-actions class="py-0 px-0">
                                                            <v-btn block text tile @click="redirect(course)">Seleccionar curso</v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </template>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<style>
    .embed-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
    }
    .embed-container iframe {
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
<script>

const success = new Audio('/audio/correct.wav')
const error   = new Audio('/audio/error.wav')
const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']


export default {
    props:['language','questions'],
    data: () => ({
        image_url:"/storage/langs_disk/",
        introduction: true,
        levels:"",
        question_index:0,
        levels_index:0,

        check_response_flag:false,

        selected_response: undefined,
        current_question:"",

        error_class:"red--text v-item--active v-list-item--active",
        correct_class:"green--text v-item--active v-list-item--active",

        level_responses:[],

        results:false,

        loading:false,

        courses:[],

    }),

    mounted(){
        this.levels = Object.keys(this.questions)
        this.change_question(this.question_index, this.levels[this.levels_index])
    },

    computed:{
        order_courses:function(){
            let order_courses = []
            for(let course of this.courses){
                course.date = course.start_date.split('-').reverse()
                course.date[1] = meses[parseInt(course.date[1])-1]
                course.date = course.date.join('/')
                course.spaces = course.student_limit - course.number_students <= course.rm_students ? course.student_limit - course.number_students : course.rm_students
                order_courses.push(course)
            }

            return order_courses
        },
    },

    watch:{
        results:function(val){
            if(val === true){
                this.loading = true

                axios.get("", { params:{ ajax:true, level:this.levels[this.levels_index] }})
                .then(response => {
                    this.courses = response.data.courses
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                })
            }
        }
    },

    methods:{
        change_question:function(index, level)
        {
            this.check_response_flag = false
            this.selected_response   = ""
            
            if(index < this.questions[level].questions.length){
                this.current_question = this.questions[level].questions[index]
                this.question_index += 1;
                return

            }else if(this.levels.length > (this.levels_index + 1)){

                let counter = 0;

                for(let response of this.level_responses){
                    if(!response){
                        counter++;
                        if(counter > 2){
                            this.results = true
                            return
                        }
                    }
                }

                this.question_index = 0
                this.levels_index  += 1

                this.level_responses = []

                this.change_question(this.question_index, this.levels[this.levels_index])
                return

            }else{
                this.results = true
            }
        },

        check_response:function(){
            this.current_question.options[this.selected_response].correct ? success.play() : error.play()
            
            this.level_responses.push(this.current_question.options[this.selected_response].correct)

            this.check_response_flag = true
        },

        redirect:function(course){
            window.location = '/register?course_id='+course.folio;
        },
    }
}
</script>